import tippy from 'tippy.js';

const tooltips = document.querySelectorAll('.tooltip');

class Tooltip {
    init() {
        if (!tooltips) return

        this.initInteger();
        this.initTooltip();
    }

    initInteger() {
        tooltips.forEach( (el, i) => {
            this.integer(el, i);
        })
    }

    initTooltip() {
        tippy('[data-tippy-content]', {
            animation: 'scale',
            duration: 200,
            delay: [100, 150],
            maxWidth: 350,
            theme: 'light',
            offset: [0, 20],
            placement: 'bottom',
        });
    }

    integer = (element, index) => element.innerHTML = index + 1
}

export default new Tooltip();